'use client';

import type { DividerProps as MantineDividerProps } from '@mantine/core';
import { Divider as MantineDivider } from '@mantine/core';

import type { LockedProps } from '../types';

type DividerProps = Omit<MantineDividerProps, LockedProps>;

export const Divider = (props: DividerProps) => {
  return <MantineDivider {...props} />;
};
